/**
 * Created by caozh on 2018.05.04.
 */

;(function () {

    paginationCtrl.$inject = ['$scope'];
    angular
        .module('DSSXAPP')
        .component('pagination', {
            template:'<div class="common-pagination-component"><span class="fn-btn page-btn" ng-class="{disabled: vm.currentpage === 1}" ng-click="vm.lastPage()"><span class="triangle-l"></span></span> <span ng-repeat="i in vm.pageArr"><span ng-bind="i" ng-show="i != vm.currentPage" ng-click="vm.jumpPage(i)" class="page-btn"></span> <span ng-bind="i" ng-show="i == vm.currentPage" ng-click="vm.jumpPage(i)" class="page-btn-active"></span></span> <span class="fn-btn page-btn" ng-class="{disabled: vm.currentpage === vm.numberOfPage}" ng-click="vm.nextPage()"><span class="triangle-r"></span></span> <span ng-show="vm.onlyPagination" class="onlyPaginationTips">共<span ng-bind="vm.numberOfPage">0</span>页</span> <span ng-show="!vm.onlyPagination" class="jump-block"><span>共<span ng-bind="vm.numberOfPage">0</span>页</span> Go to Page <input type="number" ng-model="vm.jumpNumber"> <button ng-click="vm.jumpPage(vm.jumpNumber)" class="goto-btn">Go</button></span></div>',
            bindings: {
                // 每页显示多少条数据
                dataperpage: '<',
                // 总共有多少条数据
                numberofdata: '<',
                // 每次显示多少个页码
                numberofshow: '<',
                // 当前的页码
                currentpage: '<',
                // 是否只显示页码，不显示输入跳转
                onlypagination: '<',
                // 页码改变事件，返回请求的页码
                changePage: '&'

            },
            controllerAs: 'vm',
            controller: paginationCtrl
        });

    function paginationCtrl($scope) {

        this.$onInit = function() {
            // 每页多少条数据
            this.dataPerPage = this.dataperpage ? this.dataperpage : 20;
            // 总共多少条数据
            this.numberOfData = this.numberofdata ? this.numberofdata : 0;
            // 显示多少个页码
            this.numberOfShow = this.numberofshow ? this.numberofshow : 5;
            // 当前的页码
            this.currentPage = this.currentpage ? this.currentpage : 1;
            // 是否只显示页码，不显示输入跳转
            this.onlyPagination = this.onlypagination === true ? this.onlypagination : false;
            // 总共有多少个页面
            this.numberOfPage = Math.ceil(this.numberOfData/this.dataPerPage);
            // 数字输入框的值
            this.jumpNumber = null;
            // 页码数组
            this.pageArr = [];

            // 控制页码的显示
            this.ctrlPageShow = function() {
                this.pageArr = [];
                // 如果页码总数少于等于指定显示的页码数量：无需操作
                if (this.numberOfPage <= this.numberOfShow) {
                    for(var i = 1; i <= this.numberOfPage; i++) {
                        this.pageArr.push(i);
                    }
                }
                // 如果页码总数大于等于指定显示的页码数量：重新计算页码数组
                if (this.numberOfPage > this.numberOfShow) {
                    if (this.currentPage <= Math.floor(this.numberOfShow/2)) {
                        for (var n = 1; n <= this.numberOfShow; n++) {
                            this.pageArr.push(n);
                        }
                    }
                    if (this.currentPage >= this.numberOfPage - Math.floor(this.numberOfShow/2) + 1) {
                        for (var j = this.numberOfPage - this.numberOfShow + 1; j <= this.numberOfPage; j++) {
                            this.pageArr.push(j);
                        }
                    }
                    if (this.currentPage > Math.floor(this.numberOfShow/2) && this.currentPage < this.numberOfPage - Math.floor(this.numberOfShow/2) + 1) {
                        if (this.numberOfShow%2 != 0) {
                            for (var k = this.currentPage - Math.floor(this.numberOfShow/2); k <= this.currentPage + Math.floor(this.numberOfShow/2); k++) {
                                this.pageArr.push(k);
                            }
                        }
                        if (this.numberOfShow%2 == 0) {
                            for (var m = this.currentPage - Math.floor(this.numberOfShow/2) + 1; m <= this.currentPage + Math.floor(this.numberOfShow/2); m++) {
                                this.pageArr.push(m);
                            }
                        }
                    }
                }
            };

            // 初始化页码
            this.ctrlPageShow();

            // 跳转到上一页
            this.lastPage = function () {
                if (this.currentPage <= 1) {
                    return true;
                } else {
                    this.changePage({page: this.currentPage - 1});
                }
            };

            // 跳转到下一页
            this.nextPage = function () {
                if (this.currentPage >= this.numberOfPage) {
                    return true;
                } else {
                    this.changePage({page: this.currentPage + 1});
                }
            };

            // 跳转到指定页面
            this.jumpPage = function (page) {
                if (page) {
                    var page = parseInt(page);
                    // 事件防抖：如果页码没变，则无需操作
                    if (this.currentPage == page) {
                        return true;
                    } else {
                        if (page <= 1) {
                            page = 1;
                        }
                        if (page >= this.numberOfPage) {
                            page = this.numberOfPage;
                        }
                        this.changePage({page: page});
                        this.jumpNumber = null;
                    }
                }
            };

            // 监听属性变化
            this.$onChanges = function (change) {
                // 更新数据总量
                if (change.numberofdata) {
                    this.numberOfData = change.numberofdata.currentValue;
                }
                // 更新当前页码
                if (change.currentpage) {
                    this.currentPage = change.currentpage.currentValue;
                }
                // 重新计算分页总数
                this.numberOfPage = Math.ceil(this.numberOfData/this.dataPerPage);
                // 更新页码条
                this.ctrlPageShow();
            };
        };

    }

})();